import React from 'react';
import PropTypes from 'prop-types';

import { Input } from '../Inputs';
import FormRow from '../FormRow';
import Label from '../Label';
import FormErrors from '../FormErrors';

import styles from './styles.scss';

const labelStyle = { paddingLeft: 10, color: '#333', marginBottom: 4 };
export default function FormField({
    component: Component = Input,
    id,
    label,
    required,
    labelClassName,
    inputClassName,
    errorStyle,
    shakeError,
    errors,
    wrapAs,
    children,
    ...rest
}) {
    return (
        <FormRow as={wrapAs}>
            {label && (
                <div className={styles.labelContainer}>
                    <Label
                        style={rest.builderInput ? labelStyle : null}
                        htmlFor={id}
                        hasError={!!errors}
                        className={labelClassName}
                    >
                        {label} {required && <span>*</span>}
                    </Label>
                </div>
            )}
            <Component id={id} className={inputClassName} hasError={!!errors} {...rest} />
            {children}
            {errors && <FormErrors error={errors} errorStyle={errorStyle} shake={shakeError} />}
        </FormRow>
    );
}

FormField.propTypes = {
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    wrapAs: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType, PropTypes.func]),
    label: PropTypes.string,
    id: PropTypes.string,
    labelClassName: PropTypes.string,
    inputClassName: PropTypes.string,
    errorStyle: PropTypes.object,
    children: PropTypes.node,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    shakeError: PropTypes.bool,
    errors: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.array]),
};
